import React from "react";
import { Typography } from "antd";
import {
  ACADEMY_ROUNDED_BADGE_STYLE,
  ACADEMY_ROUNDED_BADGE_STYLE_COMPACT,
  getBadgeTextColor,
  getPaymentStatusColor,
  getPaymentStatusLabel,
  PAYMENT_STATUS_COLORS,
  PROGRAM_STUDENT_STATUS_COLORS,
  PROGRAM_STUDENT_STATUS_LABELS,
  QUALIFICATION_STATUS_COLORS,
  QUALIFICATION_STATUS_LABELS,
  GLOBAL_PAYMENT_STATUS_COLORS,
  PaymentGlobalStatus,
  EQUIPMENT_RENT_STATUS_COLORS,
  EQUIPMENT_RENT_STATUS_LABELS,
} from "../../constants/academyStatusColors";

const { Text } = Typography;

type BadgeVariant = "default" | "compact";

interface AcademyStatusBadgeProps {
  background: string;
  label: string;
  variant?: BadgeVariant;
}

export const AcademyStatusBadge = ({
  background,
  label,
  variant = "default",
}: AcademyStatusBadgeProps) => (
  <Text
    style={{
      ...(variant === "compact"
        ? ACADEMY_ROUNDED_BADGE_STYLE_COMPACT
        : ACADEMY_ROUNDED_BADGE_STYLE),
      background,
      color: getBadgeTextColor(background),
    }}
  >
    {label}
  </Text>
);

interface PaymentStatusBadgeProps {
  status: string;
  label?: string;
  variant?: BadgeVariant;
}

export const PaymentStatusBadge = ({
  status,
  label,
  variant = "default",
}: PaymentStatusBadgeProps) => (
  <AcademyStatusBadge
    background={getPaymentStatusColor(status)}
    label={label ?? getPaymentStatusLabel(status)}
    variant={variant}
  />
);

interface ProgramStudentStatusBadgeProps {
  status: string;
  variant?: BadgeVariant;
}

export const ProgramStudentStatusBadge = ({
  status,
  variant = "compact",
}: ProgramStudentStatusBadgeProps) => (
  <AcademyStatusBadge
    background={
      PROGRAM_STUDENT_STATUS_COLORS[status] || PAYMENT_STATUS_COLORS.unpaid
    }
    label={PROGRAM_STUDENT_STATUS_LABELS[status] || status}
    variant={variant}
  />
);

interface QualificationStatusBadgeProps {
  status: string;
  variant?: BadgeVariant;
}

export const QualificationStatusBadge = ({
  status,
  variant = "default",
}: QualificationStatusBadgeProps) => (
  <AcademyStatusBadge
    background={QUALIFICATION_STATUS_COLORS[status] || "blue"}
    label={QUALIFICATION_STATUS_LABELS[status] || status}
    variant={variant}
  />
);

interface GlobalPaymentStatusBadgeProps {
  status: PaymentGlobalStatus;
  label: string;
  variant?: BadgeVariant;
}

interface EquipmentRentStatusBadgeProps {
  status: string;
  variant?: BadgeVariant;
}

export const EquipmentRentStatusBadge = ({
  status,
  variant = "default",
}: EquipmentRentStatusBadgeProps) => (
  <AcademyStatusBadge
    background={EQUIPMENT_RENT_STATUS_COLORS[status] || "blue"}
    label={EQUIPMENT_RENT_STATUS_LABELS[status] || status}
    variant={variant}
  />
);

export const GlobalPaymentStatusBadge = ({
  status,
  label,
  variant = "default",
}: GlobalPaymentStatusBadgeProps) => {
  const bg =
    status === "al_dia" && label.includes("pendientes")
      ? GLOBAL_PAYMENT_STATUS_COLORS.pendiente
      : GLOBAL_PAYMENT_STATUS_COLORS[status] || "blue";

  return <AcademyStatusBadge background={bg} label={label} variant={variant} />;
};
